"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mocks_json_1 = __importDefault(require("./mocks.json"));
/**
 * normalizador del modulo MODULO_BANNER
 * @param {object} fields
 * @returns
 */
const bannerNormalizer = (data) => {
    try {
        let res = null;
        const { fields } = data;
        if (fields) {
            const showMobile = fields.showMobile || false;
            const backgroundColor = fields.backgroundColor || "transparent";
            const cardShadow = fields.cardShadow || true;
            res = Object.assign(Object.assign({}, mocks_json_1.default["Card-1"]), { showMobile: showMobile, backgroundColor: backgroundColor, cardShadow: cardShadow });
            const alt = fields.altSEO || "";
            const title = fields.title || fields.altSEO || "";
            const imageDesktop = fields.imgDesktop;
            const imageDesktopSvg = fields.imgDesktopWebp;
            const imgTablet = fields.imgTablet;
            const imgTabletSvg = fields.imgTabletWebp;
            const imgMobile = fields.imgMobile;
            const imgMobileSvg = fields.imgMobileWebp;
            const objectFit = fields.objectFit || "cover";
            const objectPosition = fields.Position || "center center";
            const videoMarginTop = fields.videoMarginTop || null;
            const mp4 = fields.mp4 || null;
            if (mp4) {
                res["mp4"] = {
                    alt,
                    title,
                    mp4,
                    cardShadow,
                    videoMarginTop,
                };
            }
            const webm = fields.webm || null;
            if (webm) {
                res["webm"] = {
                    webm,
                    alt,
                    title,
                    cardShadow,
                    videoMarginTop,
                };
            }
            if (imageDesktop) {
                res["Image-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Image"]), { src: "https://prod.cms.col.movistar.es" + imageDesktop, alt,
                    title,
                    objectFit,
                    objectPosition });
            }
            if (imageDesktop && imageDesktopSvg) {
                res["Image-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Image"]), { src: "https://prod.cms.col.movistar.es" + imageDesktop, srcWebp: "https://prod.cms.col.movistar.es" + imageDesktopSvg, alt,
                    title,
                    objectFit,
                    objectPosition });
            }
            if (imgTablet && imgTabletSvg) {
                res["Image-tablet"] = Object.assign(Object.assign({}, mocks_json_1.default["Image"]), { src: "https://prod.cms.col.movistar.es" + imgTablet, srcWebp: "https://prod.cms.col.movistar.es" + imgTabletSvg, alt,
                    title,
                    objectFit,
                    objectPosition });
            }
            if (imgMobile && imgMobileSvg) {
                res["Image-mobile"] = Object.assign(Object.assign({}, mocks_json_1.default["Image"]), { src: "https://prod.cms.col.movistar.es" + imgMobile, srcWebp: "https://prod.cms.col.movistar.es" + imgMobileSvg, alt,
                    title,
                    objectFit,
                    objectPosition });
            }
            if (fields.svg) {
                res["Glyph-2"] = Object.assign(Object.assign({}, mocks_json_1.default["Glyph"]), { src: "https://prod.cms.col.movistar.es" + fields.svg, alt });
            }
            res["Characteristics-1"] = {};
            if (fields.characteristics &&
                Array.isArray(fields.characteristics) &&
                fields.characteristics.length > 0) {
                fields.characteristics.map((charac, index) => {
                    if (charac) {
                        res["Characteristics-1"][`Text-${index + 1}`] = Object.assign(Object.assign({}, mocks_json_1.default["Characteristics"]["Text"]), { text: charac });
                    }
                });
            }
        }
        return res;
    }
    catch (error) {
        console.error(error);
        return null;
    }
};
exports.default = bannerNormalizer;
//# sourceMappingURL=index.js.map